// 투자계획 API
import axiosInstance from './axiosInstance';

// 계좌별 투자계획 조회
export const fetchInvestPlan = (accountName) =>
  axiosInstance.get('/invest-plan', { params: { account_name: accountName } }).then(r => r.data);

// 전체 통합 조회
export const fetchInvestPlanSummary = () =>
  axiosInstance.get('/invest-plan/summary').then(r => r.data);

// 섹터 비율 저장 (UPSERT / DELETE)
export const saveSectorPlan = (body) =>
  axiosInstance.post('/invest-plan/sector/save', body).then(r => r.data);

// 종목 가중치 저장 (UPSERT / DELETE)
export const saveStockPlan = (body) =>
  axiosInstance.post('/invest-plan/stock/save', body).then(r => r.data);

// 추가 가능한 섹터 목록 (미등록, 중복제거)
export const fetchAvailableSectors = (accountName) =>
  axiosInstance.get('/invest-plan/sectors/available', { params: { account_name: accountName } }).then(r => r.data);

// 기본 투자계획 데이터 생성 (관리자 전용)
export const initDefaultPlan = (body) =>
  axiosInstance.post('/invest-plan/init-default', body).then(r => r.data);
